import { useMutation, useQueryClient } from '@tanstack/react-query'
import Service from 'Service'
import useStores from 'hooks/useStores'
import uiStore from 'stores/uiStore'
import AppNotifications from 'Constants/AppNotifications/AppNotifications'
import { invoicesQueryKey } from './queryKeys'

export function useDeleteInvoiceMutation(initial = 0, take = 500) {
  const queryClient = useQueryClient()
  const { companyStore } = useStores()
  const companyKey = companyStore.selectedCompany?.Keycompany
  const queryKey = invoicesQueryKey(companyKey, initial, take)

  return useMutation({
    mutationFn: invoice => Service.InvoiceDocuments.deleteInvoice(invoice),
    onMutate: async invoice => {
      if (!companyKey) return {}
      await queryClient.cancelQueries({ queryKey })
      const previous = queryClient.getQueryData(queryKey)
      queryClient.setQueryData(queryKey, current =>
        (current ?? []).filter(x => x.Id !== invoice.Id)
      )
      return { previous }
    },
    onError: (_err, _invoice, context) => {
      if (context?.previous !== undefined && companyKey) {
        queryClient.setQueryData(queryKey, context.previous)
      }
      uiStore.addNotification(AppNotifications.INVOICE_DELETE_FAIL)
    },
    onSuccess: response => {
      if (response?.status === 200) {
        uiStore.addNotification(AppNotifications.INVOICE_DELETE_SUCCESS)
      } else {
        uiStore.addNotification(AppNotifications.INVOICE_DELETE_FAIL)
      }
    },
    onSettled: () => {
      if (companyKey) {
        queryClient.invalidateQueries({ queryKey })
      }
    }
  })
}
